import { Link } from "react-router-dom";
import { termStatus, deDate } from "@/lib/bannerLayout";

const TONE = { expired: "text-red-600", ending: "text-amber-700", planned: "text-sky-700" };

export function Legend() {
  const items = [
    ["border-2 border-dashed border-white/70", "Freies Logofeld"],
    ["border-2 border-amber-300", "Läuft in 4 Wochen aus"],
    ["border-2 border-dashed border-red-400 bg-red-900/30", "Laufzeit abgelaufen"],
    ["border-2 border-dashed border-sky-300 bg-sky-400/40", "Geplant (startet später)"],
  ];
  return (
    <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-600" data-testid="banner-legend">
      {items.map(([cls, l]) => <span key={l} className="inline-flex items-center gap-1.5"><span className={`h-3.5 w-6 rounded-sm bg-[#005448] ${cls}`} />{l}</span>)}
      <span className="inline-flex items-center gap-1.5"><span className="h-3.5 w-6 rounded-sm bg-slate-600" style={{ backgroundImage: "repeating-linear-gradient(45deg, rgba(255,255,255,0.35) 0 3px, transparent 3px 6px)" }} />Sperrbereich (Sicht verdeckt)</span>
    </div>
  );
}

export function SlotList({ slots, nums, byId, partners, usedOn, today, onOpen }) {
  const ordered = [...slots].sort((a, b) => nums[a.id] - nums[b.id]);
  const waiting = partners.filter((p) => p.booked && !usedOn[p.id]);
  return (
    <div className="grid gap-4 grid-cols-[minmax(0,1fr)] lg:grid-cols-[minmax(0,1fr)_280px]">
      <div className="rounded-xl border border-slate-200 bg-white divide-y divide-slate-100" data-testid="banner-slot-list">
        {ordered.map((s) => {
          const p = byId[s.customer_id];
          const st = termStatus(p, today);
          return (
            <button key={s.id} type="button" onClick={() => onOpen(s.id)} className="w-full flex items-center gap-3 px-4 py-2 text-left text-sm hover:bg-slate-50 transition-colors" data-testid={`banner-list-row-${nums[s.id]}`}>
              <span className="w-12 shrink-0 text-xs font-semibold text-slate-400">Feld {nums[s.id]}</span>
              {p ? <span className="min-w-0 flex-1 truncate font-medium text-slate-900">{p.name}{!p.logo && !p.print && <span className="ml-2 text-xs font-normal text-amber-700">Logo fehlt</span>}</span>
                : <span className="flex-1 text-emerald-700 font-medium">frei</span>}
              {p && <span className={`text-xs ${st ? TONE[st.key] : "text-slate-500"}`}>{st ? st.label : p.until ? `bis ${deDate(p.until)}` : "unbefristet"}</span>}
            </button>
          );
        })}
        {!slots.length && <p className="px-4 py-6 text-sm text-slate-400">Noch keine Logofelder angelegt.</p>}
      </div>
      {waiting.length > 0 && <div className="rounded-xl border border-amber-200 bg-amber-50/60 p-4 text-sm" data-testid="banner-waiting">
        <p className="font-semibold text-amber-900">Gebucht, aber noch ohne Feld</p>
        <p className="text-xs text-amber-800 mb-2">Im Profil eingetragen – bitte einem Logofeld zuordnen.</p>
        {waiting.map((p) => <Link key={p.id} to={`/partner/${p.id}`} className="block text-slate-800 hover:underline" data-testid={`banner-waiting-${p.id}`}>{p.name}</Link>)}
      </div>}
    </div>
  );
}
